import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import propTypes from 'prop-types';
import ThemeContext from './configContext';

var Dark = function Dark(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(ThemeContext.Provider, _extends({}, props, {
    value: "dark"
  }), children);
};

export default Dark;
Dark.propTypes = {
  children: propTypes.node
};